import { Injectable, inject } from "@angular/core";
import moment from "moment";
import * as range from "moment-range";
import { firstValueFrom } from "rxjs";
import { HelgdagarDTO } from "~app/common/models/kalender/HelgdagarDTO";
import { ApiClientService } from "../services/api-client.service";
import { DateUtils } from "../utils/date-utils";

export const momentRange = range.extendMoment(moment as any);

@Injectable({
    providedIn: "root"
})
export class CalendarService {
    private readonly apiClientService = inject(ApiClientService);

    private readonly KEY_FORMAT = DateUtils.dateformat;
    private readonly helgdagar: Map<string, Date>;
    private loadedRange: range.DateRange;
    constructor() {
        this.helgdagar = new Map<string, Date>();
    }

    async initHelgdagar(fran: string, till: string) {
        if (this.hasLoadedRange(fran, till)) {
            return;
        }

        this.loadedRange = momentRange.range(moment(fran), moment(till));

        const params = {
            fran: new Date(fran).toISOString(),
            till: new Date(till).toISOString()
        };

        const response = await firstValueFrom(this.apiClientService.get<HelgdagarDTO>("Kalender/GetHelgdagar", false, params));
        response.helgdagar.forEach(d => this.helgdagar.set(moment(d).format(this.KEY_FORMAT), d));
    }

    isHelgdag = (date: string | Date | moment.Moment) => {
        if (typeof date === "string") {
            return this.helgdagar.has(date.substring(0, 9));
        }
        if (date instanceof Date) {
            return this.helgdagar.has(moment(date).format(this.KEY_FORMAT));
        }
        return this.helgdagar.has(date.format(this.KEY_FORMAT));
    };

    isWeekendOrHelgdag = (date: string | moment.Moment) => {
        if (typeof date === "string") {
            const d = new Date(date);
            return d.getDay() === 0 || d.getDay() === 6 || this.helgdagar.has(d.toISOString().substring(0, 10));
        }
        return date.day() === 0 || date.day() === 6 || this.helgdagar.has(date.format(this.KEY_FORMAT));
    };

    hasLoadedRange = (fran: string, till: string): boolean => {
        const from = moment(fran);
        const to = moment(till);
        const requestedRange = momentRange.range(from, to);

        return this.loadedRange?.contains(requestedRange); // inclusive by default
    };
}
